module.exports = __webpack_public_path__ + "img/prism.ff11e138.png";